import React from 'react';

interface IProps {
  style?: React.CSSProperties | undefined;
  width?: number | string;
  height?: number | string;
  embed: string;
}

export const SocialEmbed: React.FC<IProps> = (props) => {
  const {width = 300, height = 300} = props;
  return (
    <iframe
      srcDoc={`<html><body style="margin:0;overflow:hidden;">${props.embed}</body></html>`}
      style={{
        top: 0,
        left: 0,
        width,
        height,
        border: 0,
        ...props.style,
      }}
      allowFullScreen={true}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    />
  );
};
